module.exports = __webpack_public_path__ + "static/img/weibo-code.929bd5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/footer/weibo-code.png
// module id = n6qk
// module chunks = 32